module.exports = __webpack_public_path__ + "img/hr-sand-decal-06.f139fd4f.png";